<template>
  <div>
    <!--CONSULTAR INFORMACOES -->
    <ed-modal
      title="Consultar Informações no eSocial"
      saveName="Consultar"
      width="80%"
      :modal="boolExibirConsultaProtocolo"
      :isModal="false"
    >
      <el-row slot="modal-content">
        <ed-alert class="mb-3">
          <div slot="description">
            Escolha abaixo o que gostaria de consiltar diretamente no eSocial
          </div>
        </ed-alert>

        <el-tabs type="border-card" v-model="tabSelected">
          <el-tab-pane
            label="Situação do Protocolo"
            name="tab-consulta-protocolo"
          >
            <span slot="label">Situação do Protocolo</span>
            <consulta-protocolo
              :lstEmpresa="lstEmpresa"
              :loadingEmpresa="loadingEmpresa"
              :loadingFuncionario="loadingFuncionario"
            />
          </el-tab-pane>

          <el-tab-pane label="Informações do Recibo" name="tab-consulta-recibo">
            <span slot="label">Informações do Recibo</span>
            <consulta-recibo
              :lstEmpresa="lstEmpresa"
              :loadingEmpresa="loadingEmpresa"
              :loadingFuncionario="loadingFuncionario"
            />
          </el-tab-pane>

          <el-tab-pane
            label="Eventos do Empregador"
            name="tab-consulta-evento-empresa"
          >
            <span slot="label">Eventos do Empregador</span>
            <consulta-evento-empresa
              :lstEmpresa="lstEmpresa"
              :loadingEmpresa="loadingEmpresa"
              :loadingFuncionario="loadingFuncionario"
            />
          </el-tab-pane>

          <el-tab-pane
            label="Eventos do Trabalhador"
            name="tab-consulta-evento-trabalhador"
          >
            <span slot="label">Eventos do Trabalhador</span>
            <consulta-evento-trabalhador
              :lstEmpresa="lstEmpresa"
              :loadingEmpresa="loadingEmpresa"
              :loadingFuncionario="loadingFuncionario"
            />
          </el-tab-pane>
        </el-tabs>
      </el-row>
    </ed-modal>

    <!--GERAR NOVO LOTE -->
    <GerarLote :parent="this" :showForm="showFormEdit" />
    <EmailLote :parent="this" :showForm="showFormEmail" />
    <Item :showForm="showFormItem" />

    <ed-modal
      :title="'Processar Lote no eSocial Lote ' + this.formData.lote"
      :modal="showFormProcessar"
      width="90%"
    >
      <div slot="modal-content">
        <Processar :formData="formData" />
      </div>
    </ed-modal>

    <ed-table
      registerName="Gerar Novo Lote"
      :onRegister="onRegister"
      :onSearch="getEsocialLotes"
      :onDelete="onDelete"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
      :onFilter="getEsocialLotes"
      :filterBadge="filterBadge"
    >
      <div slot="table-filter-content">
        <ed-form :model="formFilter">
          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            label="Empresa"
            v-model="formFilter.id_empresa"
            :items="lstEmpresa"
            :loading="loadingEmpresa"
            @input="getFuncionario"
            @search="getEmpresa"
            clearable
            remote
          />

          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            label="Trabalhador"
            v-model="formFilter.id_funcionario"
            :items="lstFuncionario"
            :loading="loadingFuncionario"
            @search="getFuncionario"
            clearable
            remote
          />

          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            label="Layout"
            v-model="formFilter.layout"
            itemValue="codigo"
            itemText="esocial"
            :items="lstLayout"
            clearable
          />
        </ed-form>
      </div>

      <div slot="table-button">
        <ed-button
          v-if="$root.$session.validarPacote(30)"
          type="success"
          @click="boolExibirConsultaProtocolo = !boolExibirConsultaProtocolo"
          label="Consultar Informações no eSocial"
          icon="fa fa-search"
        />
      </div>
    </ed-table>
  </div>
</template>

<script>
import EdTable from "common/table";
import Rest from "common/rest";
import { EdForm, EdButton, EdInputSelect, EdModal, EdAlert } from "template";
import ConsultaProtocolo from "./includes/consulta-protocolo.vue";
import ConsultaRecibo from "./includes/consulta-recibo.vue";
import ConsultaEventoTrabalhador from "./includes/consulta-evento-trabalhador.vue";
import ConsultaEventoEmpresa from "./includes/consulta-evento-empresa.vue";

import GerarLote from "./gerar";
import EmailLote from "./email/index";
import Processar from "./processar/index";
import Item from "./item/index";

export default {
  name: "esocial-lotes",
  mixins: [Rest],
  components: {
    EdTable,
    GerarLote,
    EdButton,
    EmailLote,
    Processar,
    Item,
    EdForm,
    EdInputSelect,
    EdModal,
    EdAlert,
    ConsultaProtocolo,
    ConsultaRecibo,
    ConsultaEventoTrabalhador,
    ConsultaEventoEmpresa,
  },
  provide() {
    return {
      formData: this.formData,
      getEmpresa: this.getEmpresa,
      getFuncionario: this.getFuncionario,
      getLayout: this.getLayout,
      parent: this,
    };
  },
  data() {
    return {
      response: {},
      pagination: {},
      formData: {},
      tableHead: [
        {
          key: "lote",
          sortable: true,
          width: "150px",
          label: "Lote",
        },
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "layout",
          sortable: true,
          label: "Layout",
        },
        {
          key: "eventos",
          sortable: true,
          label: "Eventos",
        },
        // {
        //   key: "recibo",
        //   sortable: true,
        //   label: "Recibo",
        // },
        {
          key: "arquivo",
          show_arquivo: true,
          label: "Arquivo",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
      tableData: [],
      lstEmpresa: [],
      lstFuncionario: [],
      lstLayout: [],
      formFilter: {
        id_empresa: null,
        id_funcionario: null,
        layout: null,
      },
      showFormEdit: false,
      showFormEmail: false,
      showFormProcessar: false,
      loadingTable: false,
      loadingEmpresa: false,
      loadingFuncionario: false,
      boolExibirConsultaProtocolo: false,
      showFormItem: false,
      filterBadge: 0,
      tabSelected: "tab-consulta-protocolo",
    };
  },

  created() {
    this.getEsocialLotes(this.$route.params.lote);
  },

  mounted() {
    this.getEmpresa();
    this.getLayout();
  },

  methods: {
    onRegister(init) {
      this.showFormEdit = !this.showFormEdit;
    },

    onEmail(data) {
      this.formData = {
        id: data.id,
        lote: data.lote,
        layout: data.layout,
      };
      this.showFormEmail = !this.showFormEmail;
    },

    onItem(data) {
      this.formData = Object.assign(
        {
          id: data.id,
          lote: data.lote,
          layout: data.layout,
          avulso: data.avulso,
        },
        {}
      );
      this.showFormItem = !this.showFormItem;
    },

    onProcessar(data) {
      this.formData = {
        id: data.id,
        lote: data.lote,
        layout: data.layout,
      };
      this.showFormProcessar = !this.showFormProcessar;
    },

    onDelete(data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        self.loadingTable = true;

        this.post("esocial/lotes/deletar", { ids: data }).then((result) => {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {
            self.getEsocialLotes();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getLayout(_search) {
      this.lstLayout = [];

      this.get("esocial/tabelas/conteudo/9", { search: _search }).then(
        (result) => {
          result = result[0];

          if (result.status == 200) {
            this.lstLayout = result.data.data;
          }
        }
      );
    },

    getEmpresa(_search) {
      this.lstEmpresa = [];
      this.loadingEmpresa = true;

      this.get("/empresa", { search: _search }).then((result) => {
        result = result[0];
        if (result.status == 200) {
          this.lstEmpresa = result.data.data;
        }
        this.loadingEmpresa = false;
      });
    },

    getFuncionario(_search) {
      if (!this.formFilter.id_empresa) return;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, {
        search: _search,
      }).then((result) => {
        result = result[0];
        if (result.status == 200) {
          this.lstFuncionario = result.data.data;
        }
        this.loadingFuncionario = false;
      });
    },

    getEsocialLotes(_search, _page) {
      this.loadingTable = true;
      this.response = {};

      this.filterBadge =
        (this.formFilter.id_empresa ? 1 : 0) +
        (this.formFilter.layout ? 1 : 0) +
        (this.formFilter.id_funcionario ? 1 : 0);

      this.get("esocial/lotes", {
        page: _page,
        search: _search,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];
        this.response = result;

        this.loadingTable = false;

        if (result.status == 200) {
          this.formataLista(result);
        }
      });
    },

    formataLista(result) {
      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        let info_evento =
          '<br><span style="color:' +
          (arrData[i].total_evento_enviado ? "green" : "") +
          '"><b>Eventos enviado:</b> ' +
          arrData[i].total_evento_enviado +
          "</span>";

        info_evento +=
          '<br><span style="color:' +
          (arrData[i].total_evento_erro ? "red" : "") +
          '"><b>Eventos com erro:</b> ' +
          arrData[i].total_evento_erro +
          "</span>";

        var item = {
          lote: arrData[i].lote,
          empresa: arrData[i].empresa.nome,
          layout: arrData[i].layout,
          eventos:
            "<span>Total eventos: " +
            arrData[i].total_evento +
            "</span>" +
            info_evento,
          arquivo: arrData[i].arquivo,
          protocolo: arrData[i].protocolo,
          recibo: arrData[i].recibo,
          updated_at: this.toDate(arrData[i].updated_at, false),
          _data: arrData[i],
          buttons: [
            {
              icon: "fa fa-envelope",
              color: "warning",
              title: "Enviar Lote por Email",
              click: this.onEmail,
            },
          ],
          options: {
            disable_delete: arrData[i].processos_count,
          },
        };

        if (this.$root.$session.validarPacote(30)) {
          item.buttons.push({
            icon: "fa fa-paper-plane",
            color: "success",
            title: "Processar Lote",
            click: this.onProcessar,
          });
        }

        if (true) {
          item.buttons.push({
            icon: "fa fa-th-list",
            color: "primary",
            title: "Visualizar items no arquivo",
            click: this.onItem,
          });
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?3b279bee